export default __webpack_public_path__ + "static/media/EVM.eda43b80.jpg";